import React from 'react';

export default function Header() {
    return (
      <div className="bg-gray-900 px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">SAVE ENDANGERED ANIMALS</h2>
          <p className="mt-6 text-lg leading-8 text-gray-300">
            The world is facing a mass extinction of species. We must act now to save endangered animals from extinction.
            Search for endangered animals around you and find out how you can help save them.
          </p>
            {/* Call to Action Button */}
            <a href="https://www.worldwildlife.org/" target="_blank" rel="noopener noreferrer" className="mt-8 inline-block bg-gray-500 text-white text-base font-bold py-4 px-4 rounded hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
                    Learn How to Help at WWF
            </a>
        </div>
      </div>
    )
  }